<div class="nuevo-catalogo-container">
  <p class="heading-catalogo">Tipo</p>
  <button
    (click)="nuevoTipo()"
    mat-mini-fab
    aria-label="Agregar nuevo tipo"
    color="primary">
    <mat-icon>add</mat-icon>
  </button>
</div>
<div *ngIf="admonCatTiposStatus$ | async as tipoStatus">
  <mat-card-content class="nuevo-catalogo-card" *ngIf="tipoStatus.mostrarNuevo">
    <mat-card>
      <mat-card-header>
        <form [formGroup]="nuevoRegistro" class="nuevo-catalogo-form">
          <h3 class="heading-3">Añadir tipo</h3>
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Descripción</mat-label>
            <input
              formControlName="descripcion"
              name="descripcion"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              placeholder=""
              (input)="existeRegistro(nuevoRegistro.get('descripcion'), '')" />
            <mat-hint align="end"
              >{{ nuevoRegistro.get("descripcion")?.value.length }} /
              50</mat-hint
            >
            @if ( nuevoRegistro.get('descripcion')?.touched && nuevoRegistro
            .get('descripcion')?.hasError('campoRequerido')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if ( nuevoRegistro.get('descripcion')?.touched &&
            nuevoRegistro.get('descripcion')?.hasError('descripcionCatalogo')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            } @if ( nuevoRegistro.get('descripcion')?.touched &&
            nuevoRegistro.get('descripcion')?.hasError('descripcionDuplicad@'))
            {
            <mat-error> La descripción ya se encuentra registrada. </mat-error>
            }
          </mat-form-field>
        </form>
      </mat-card-header>
      <mat-card-actions align="end" class="nuevo-catalogo-actions">
        <button class="!uppercase" mat-stroked-button (click)="cancelar()">
          Cancelar
        </button>
        <button
          class="!uppercase"
          color="primary"
          mat-flat-button
          [disabled]="nuevoRegistro.invalid"
          (click)="guardarRegistro()">
          Guardar
        </button>
      </mat-card-actions>
    </mat-card>
  </mat-card-content>
</div>
